/**
 * TanStack Query hooks for `lifetime-commission`. Thin wrappers over ./api.
 * Query keys: ['lifetime-commission'] for the list.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	lifetimeCommissionQueryKeys,
	type CreateLifetimeCommissionBody,
	type CreateLifetimeCommissionResponse,
	type ListLifetimeCommissionResponse,
} from "./api";

export function useLifetimeCommissionList(): UseQueryResult<
	ListLifetimeCommissionResponse,
	Error
> {
	return useQuery({
		queryKey: lifetimeCommissionQueryKeys.list(),
		queryFn: list,
	});
}

export function useLifetimeCommissionCreate(): UseMutationResult<
	CreateLifetimeCommissionResponse,
	Error,
	CreateLifetimeCommissionBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: lifetimeCommissionQueryKeys.all });
		},
	});
}

export function useLifetimeCommissionDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: lifetimeCommissionQueryKeys.all });
		},
	});
}
